import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import ReactDOMServer from 'react-dom/server';

var stringifyObj = function stringifyObj(obj) {
  var objectString = '';
  obj.forEach(function (element) {
    Object.entries(element).forEach(function (entry) {
      var _entry = _slicedToArray(entry, 2),
          key = _entry[0],
          value = _entry[1];

      if (_typeof(value['$$typeof']) === 'symbol') {
        objectString = objectString + key + "'" + ReactDOMServer.renderToStaticMarkup(value) + "'";
      } else if (_typeof(value) === 'object') {
        objectString = objectString + key + JSON.stringify(value);
      } else {
        objectString = objectString + key + value;
      }
    });
  });
  return objectString;
};

export default stringifyObj;